import { Component } from '@angular/core';

@Component({
  selector: 'app-overtime',
  templateUrl: './overtime.component.html',
  styleUrl: './overtime.component.scss'
})
export class OvertimeComponent {
  products = [
    {
        code: "P001",
        name: "Laptop",
        category: "Electronics",
        quantity: 50
    },
    {
        code: "P002",
        name: "Smartphone",
        category: "Electronics",
        quantity: 120
    },
    {
        code: "P003",
        name: "Desk Chair",
        category: "Furniture",
        quantity: 200
    },
    {
        code: "P004",
        name: "Coffee Maker",
        category: "Appliances",
        quantity: 80
    },
    {
        code: "P005",
        name: "Notebook",
        category: "Stationery",
        quantity: 500
    },
    {
        code: "P006",
        name: "Headphones",
        category: "Electronics",
        quantity: 150
    },
    {
        code: "P007",
        name: "Office Desk",
        category: "Furniture",
        quantity: 30
    },
    {
        code: "P008",
        name: "Water Bottle",
        category: "Accessories",
        quantity: 300
    },
    {
        code: "P009",
        name: "Backpack",
        category: "Accessories",
        quantity: 75
    },
    {
        code: "P010",
        name: "Printer",
        category: "Electronics",
        quantity: 40
    }
  ];
}
